import { EditorChoiceHighlightsComponent } from './editor-choice-highlights/editor-choice-highlights.component';
import { EditorChoiceCardComponent } from './editor-choice-card/editor-choice-card.component';
import { ClinicalResourceCardModule } from './../clinical-resource/clinical-resource-card/clinical-resource-card.module';
import { FeedCardModule } from './../web/feed-card/feed-card.module';
/**
 * Angular import.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Components import.
 */
import { EditorChoiceComponent } from './editor-choice.component';
import { EditorChoiceDetailComponent } from './editor-choice-detail/editor-choice-detail.component';
import { EditorChoiceDetailCardComponent } from './editor-choice-detail-card/editor-choice-detail-card.component';
import { EditorChoiceDetailProfileComponent } from './editor-choice-detail-profile/editor-choice-detail-profile.component';

/**
 * Modules import.
 */
import { EditorChoiceRoutingModule } from './editor-choice-routing.module';
import { PipesModule } from './../pipes/pipes.module';
import { AppHeaderModule } from '../common/header/header.module';
import { UserProfilePicModule } from './../common/user-pofile-pic/user-profile-pic.module';
import { AnalyticsEventModule } from '../analytics-event/analytics-event.module';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ProductMaskingCardModule } from '../common/product-masking-card/product-masking-card.module';
import { DirectivesModule } from '../directives/directives.module';


@NgModule({
  declarations: [
    EditorChoiceComponent,
    EditorChoiceDetailComponent,
    EditorChoiceDetailCardComponent,
    EditorChoiceDetailProfileComponent,
    EditorChoiceHighlightsComponent,
    EditorChoiceCardComponent,
  ],
  imports: [
    EditorChoiceRoutingModule,
    PipesModule,
    CommonModule,
    AppHeaderModule,
    UserProfilePicModule,
    FeedCardModule,
    ClinicalResourceCardModule,
    AnalyticsEventModule,
    CarouselModule,
    ProductMaskingCardModule,
    DirectivesModule
  ],
  exports: [
    EditorChoiceComponent,
    EditorChoiceDetailComponent,
    EditorChoiceDetailCardComponent,
    EditorChoiceDetailProfileComponent,
    EditorChoiceHighlightsComponent,
    EditorChoiceCardComponent
  ]
})
export class EditorChoiceModule { }
